<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 16px;padding: 10px;box-shadow: 0 8px 28px rgba(0, 37, 62, 0.18) !important;">
              <span class="login-title">
                <img :src="igreja.logoUrl" width="230px">
              </span>
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Dados do membro:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-text-field light label="CPF*" color="#00695C" outlined v-mask="'###.###.###-##'" dense hide-details required v-validate="'required|cpf'" data-vv-name="cpf" type="tel" v-model="membro.cpf" @change="consultaCPF(membro.cpf)" append-outer-icon="search"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg8>
                      <v-text-field light disabled v-model="membro.nome" label="NOME" outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field light disabled v-model="membro.celula.nome" label="CÉLULA" outlined color="#00695C" required dense hide-details></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Dados do ministério:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-select outlined dense :disabled="membro.nome == ''" v-model="voluntario.ministerioId" :items="ministerios" hide-details item-text="nome" item-value="id" color="#00695C" label="MINISTÉRIO*" @input="carregaFuncoes"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-select outlined dense :disabled="voluntario.ministerioId == ''" v-model="voluntario.funcaoId" :items="funcoes" hide-details item-text="nome" item-value="id" color="#00695C" label="FUNÇÃO*" @input="carregaSetores"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-select outlined dense :disabled="voluntario.funcaoId == ''" v-model="voluntario.setorId" :items="setores" hide-details item-text="nome" item-value="id" color="#00695C" label="SETOR*"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-data-table v-if="tabela.conteudo.length > 0" :items="tabela.conteudo" :headers="tabela.cabecalho" :items-per-page="tabela.itensPorPagina" hide-default-footer style="border: 1px #aaa solid">
                        <template v-slot:top>
                          <v-toolbar flat dense color="white" style="border-radius: 10px;">
                            <v-toolbar-title class="textoUser">Ministérios que faço parte</v-toolbar-title>
                          </v-toolbar>
                        </template>
                        <template v-slot:[`item.situacao`]="{ item }">
                          <td>
                            <v-chip v-if="item.situacao == 'EM_ANALISE'" color="warning">
                              <v-icon left>mdi-alert</v-icon>EM ANÁLISE
                            </v-chip>
                            <v-chip v-if="item.situacao == 'ATIVO'" color="success">
                              <v-icon left>mdi-check-circle</v-icon>ATIVO
                            </v-chip>
                            <v-chip v-if="item.situacao == 'INATIVO'" color="error">
                              <v-icon left>mdi-alert-circle</v-icon>INATIVO
                            </v-chip>
                          </td>
                        </template>
                      </v-data-table>
                      <v-alert v-if="membro.nome && tabela.conteudo.length == 0" dense type="warning" style="margin: 0px">No momento, não participa de nenhum ministério</v-alert>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg6>
                      <v-btn dark depressed block rounded color="#00695C" style="border-radius: 28px;" large @click="salvaVoluntario">Confirmar Cadastro</v-btn>
                    </v-flex> 
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <br>
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/logoTemplusIntelite.png" width="300px">
          </a>
        </div>
        <!-- FIM INSCRIÇÃO -->

        <v-dialog v-model="dialogoCadastroConcluido" persistent max-width="500px">
          <v-card>
            <v-card-text style="padding-bottom: 0px">
              <v-container>
                <v-row dense>
                  <v-col cols="12" style="text-align: center; padding: 2px;">
                    <v-icon left color="success" size="100">check_circle</v-icon>
                    <p class="texto" style="color:#00695C">Cadastro de voluntário realizado com sucesso!</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="closeDialog">Concluir</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- INÍCIO MENSAGEM NÃO CADASTRADO -->
        <v-dialog v-model="dialogoNaoCadastrado" persistent max-width="500px">
          <v-card>
            <v-card-title>Atenção</v-card-title>
            <v-card-text style="padding-bottom: 0px">
              <v-container>
                <v-row dense>
                  <v-col cols="12" style="text-align: center; padding: 2px;">
                    <v-icon left color="warning" size="100">warning</v-icon>
                    <p class="texto" style="color: #666">O CPF informado não possui cadastro na <strong>{{ igreja.nome }}</strong>. <a href="https://templus.intelite.com.br/liberdade">Clique aqui</a> e cadastre-se agora.<br><br>Após realizar o seu cadastro, tente novamente.</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="dialogoNaoCadastrado = false">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- FIM MENSAGEM NÃO CADASTRADO -->
      </v-container>
    </div>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
// import CpfValidate from '../../componentes/validators/rules/cpf'
import { baseApiUrl } from '@/global'
import Snackbar from '../../componentes/snackbar.vue'
import { mapState } from 'vuex'
import moment from 'moment'
import axios from 'axios'
export default {
  components: { Snackbar, Loading, },
  name: 'Auth',
  computed: mapState({
    usuarioLogado: state => state.isMenuVisible,
  }),
  data: function () {
    return {
      idIgreja: '6390de5538a3bc18300a2022',
      user: {},
      eventoSelecionado: '',
      membro: {
        nome: '',
        cpf: '',
        id: '',
        celula: {
          nome: ''
        },
      },
      voluntario: {
        igrejaId: '',
        membroId: '',
        ministerioId: '',
        funcaoId: '',
        setorId: '',
        situacao: 'EM_ANALISE'
      },
      tabela: {
        cabecalho: [
          { text: 'Ministério', value: 'ministerio' },
          { text: 'Função', value: 'funcao' },
          { text: 'Setor', value: 'setor' },
          { text: 'Situação', value: 'situacao' },
        ],
        conteudo: [],
        itensPorPagina: -1
      },
      dialogoNaoCadastrado: false,
      dialogoCadastroConcluido: false,
      condicoes: [
        { value: true, text: 'SIM'},
        { value: false, text: 'NÂO'},
      ],
      ministerios: [],
      funcoes: [],
      setores: [],
      isLoading: false,
      fullPage: true,
      jaExiste: false,
      igreja: [],
      dictionary: {          
        custom: {
          dateOfBirth: {
            required: () => 'Informe a data de nascimento',
            date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
          },
        }
      },
      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Insira um e-mail válido (apenas minúsculas)'
        },
      },
    }
  },
  
  mounted: function () {
    this.carregaDados()
  },
  
  watch: {
    //
  },

  methods: {
    async carregaDados() {
      this.isLoading = true
      try {
        const response = await axios.post(baseApiUrl + 'Igrejas/infoPublica', null, { params: { igrejaId: this.idIgreja } })
        if (response.data) {
          this.igreja = response.data
          this.voluntario.igrejaId = response.data.id
        }
      } catch (error) {
        this.$refs.chamaSnackbar.snack('#FF5252', 'Erro ao carregar dados da igreja.', 'ERRO')
      } finally {
        this.isLoading = false
      }
    },

    async carregaCelulas() {
      await axios.post(baseApiUrl + 'Celulas/listarPorRedePublico', null, { params: { redeId: this.redeSelecionada } })
      .then(response => {
        if (response.data) {
          this.celulas = response.data
        }
      })
    },

    async consultaCPF(cpf) {
      var vm = this
      this.isLoading = true
      await axios.post(baseApiUrl + 'Membros/buscaMembroVoluntario', {"cpf": cpf, "igrejaId": this.igreja.id})
      .then(response => {
        if (response.data) {
          if (response.data.membro) {
            if (response.data.membro.celula.includes('NENHUMA') || !response.data.membro.celula) {
              vm.$refs.chamaSnackbar.snack("#F9A825", "Desculpe, necessário estar vinculado a uma célula. Favor procurar seu líder!", "ATENÇÃO")
            } else {
              this.membro.nome = response.data.membro.nome
              this.membro.celula.nome = response.data.membro.celula.trim()
              this.membro.id = response.data.membro.id
              this.voluntario.membroId = response.data.membro.id
              this.tabela.conteudo = response.data.voluntario
              this.carregaMinisterios()
            }
          } else {
            this.dialogoNaoCadastrado = true
          }
        }
        this.isLoading = false
      })
    },

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDatePadrao(date) {
      if (!date) return null

      const [day, month, year] = date.substr(0, 10).split('/')
      return `${year}-${month}-${day}` + " " + date.substr(11, 6)
    },

    formatDateBrz(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDateHora(date) {
      if (!date) return null

      const [year, month, day] = date.substr(0, 10).split('-')
      return `${day}/${month}/${year}` + " " + date.substr(11, 8)
    },

    closeDialog() {
      this.vigilante = Object.assign({}, this.vigilanteDefault)
      this.$validator.reset()
      window.location.reload()
    },

    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const dataA = a.fim;
      const dataB = b.fim;

      let comparison = 0;
      if (dataA > dataB) {
        comparison = 1;
      } else if (dataA < dataB) {
        comparison = -1;
      }
      return comparison;
    },

    transformaData(data, formato) {
      let date = moment(data).format(formato);
      return date
    },

    async carregaMinisterios() {
      this.voluntario.funcaoId = ''
      this.voluntario.setorId = ''
      await axios.post(baseApiUrl + 'Ministerios/listarPublicos', {
        igrejaId: this.igreja.id,
      })
      .then(response => {
        if (response.data.length > 0) {
          this.ministerios = response.data
        }
      })
    },

    async carregaFuncoes() {
      this.voluntario.funcaoId = ''
      this.voluntario.setorId = ''
      await axios.post(baseApiUrl + 'Funcoes/listarPublicasPorMinisterio', {
        igrejaId: this.igreja.id,
        ministerioId: this.voluntario.ministerioId,
      })
      .then(response => {
        if (response.data.length > 0) {
          this.funcoes = response.data
        }
      })
    },

    async carregaSetores() {
      this.voluntario.setorId = ''
      await axios.post(baseApiUrl + 'Setores/listarPublicos', {
        igrejaId: this.igreja.id,
        ministerioId: this.voluntario.ministerioId,
        funcaoId: this.voluntario.funcaoId,
      })
      .then(response => {
        if (response.data.length > 0) {
          this.setores = response.data
        }
      })
    },

    async salvaVoluntario() {
      var vm = this
      if (!this.voluntario.membroId || !this.voluntario.ministerioId || !this.voluntario.funcaoId || !this.voluntario.setorId) {
        vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos para continuar!", "ATENÇÃO")
      } else {
        this.isLoading = true
        await axios.post(baseApiUrl + 'Voluntarios/cadastro', this.voluntario)
        .then(response => {
          if (response.data) {
            if (response.data.mensagem.includes('com sucesso')) {
              this.dialogoCadastroConcluido = true
            } else if (response.data.mensagem.includes('já cadastrado com as mesmas informações')) {
              vm.$refs.chamaSnackbar.snack("#F9A825", "Já existe um cadastro de voluntário com os mesmos dados informados", "ATENÇÃO")
            }
            this.isLoading = false
          }
        })
      }
    },
  }
}
</script>

<style scoped>
/* LOGIN */

.limiter {
  width: 100%;
  margin: 0 auto;
}

.container-login {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background: linear-gradient(135deg, #5BC1A3 0%, #01B094 52%, #00695C 100%);
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
}

.texto {
  font-weight: bold;
  color: #00253E;
  font-size: 17px;
}

.login {
  min-width: 80%;
  border-radius: 16px;
  background-color: #fff;
  opacity: 0.9;
  padding-top: 15px;
  padding-bottom: 15px;
}

.login-title {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center
}

@import '../../../node_modules/vue-anka-cropper/dist/VueAnkaCropper.css'
</style>
